//Projects.js
import React, { useState } from "react";
import "./Projects.css"; // Make sure this points to your CSS file



function Projects() {
  const projects = [
    {
      id: 1,
      title: "Austism Spectrum Disorder Machine Learning Research (IEEE Conference Paper & SCCUR Conference Presentation)",
      // position: "Computational Bio. Researcher under Prof. Dharmale",
      // caption: "Co-first-authored & presented IEEE paper. Created novel machine learning algorithms to analyze electroencephalogram signals for autism detection; 94% avg. accuracy; paper cited by researchers.\nIEEE International Conference on Consumer Electronics (ICCE) 2025: Best Session Presentation Award",
      image: null,
      links: [
        { url: "https://ieeexplore.ieee.org/document/10929890", label: "IEEE Paper" },
        { url: "https://airtable.com/appJNFWOkOHEz40pf/shrKOwhOHYfBCSVKf/tblKZVnV1Tvxo70IJ", label: "SCCUR 2024 Abstracts Page" }
        // { url: "https://sites.google.com/asdrp.org/dharmale", label: "Research Lab Website" }
      ],
    },
    {
      id: 2,
      title: "Stanford Center for Artificial Intelligence in Medicine & Imaging Internship (3.8% admitted): Pneumonia Detection/Localization",
      // position: "Machine Learning/Image Processing Research Intern",
      // caption: "Diagnosed pneumonia from ~12000 low-resolution chest X-rays; focused on ethical AI usage & scalable tools for health equity in underprevileged clinics. (<5% admitted)",
      image: null,
      links: [
        { url: "https://github.com/pranav-gupta1/PneumoniaDetectionLocalization", label: "GitHub Repository" }
      ],
    },
    // {
    //   id: 3,
    //   title: "SkyGeni Inc. (produces growth insights for businesses' revenue teams)",
    //   // position: "Software Engineering Intern (first high schooler)",
    //   // caption: "Built 2 AI sales performance analysis systems saving hundreds of hours of manual parsing; presented features to C-suite; cold-emailed for opportunity—mentored by CEO Mr. Sundaresan",
    //   image: null,
    //   link: "https://www.skygeni.com/",
    // },
    {
      id: 4,
      title: "Image Processing Research (Science Fair & JEI Paper)",
      // position: "Media Processing Researcher with CS/Eng Dept. Chair",
      // caption: "First-authored Harvard JEI paper. Used ML to detect AI-generated images w/ many neural networks; presented at Synopsys Science Fair w/ trifold board; improved based on judges' feedback.\nSynopsys Science Fair 2024: 2nd Award in the category for Physical Science and Engineering",
      image: null,
      links: [
        { url: "https://www.science-fair.org/database/project_awards.php?school_year=2324&all&special_order", label: "Science Fair Award" },
        { url: "https://doi.org/10.59720/24-270", label: "Paper" },
        // { url: "https://www.asdrp.org/", label: "ASDRP" },
        // { url: "https://sites.google.com/asdrp.org/mcmahan", label: "Research Lab Website" },
      ],
    },
    {
      id: 5,
      title: "Scadnano (a UC Davis Molecular Computing Group project under Professor Doty) Contributor for Issues and Features",
      // position: "Researcher at UC Davis Molecular Computing Group",
      // caption: "Fixed issues; implemented features w/ Python & Dart; used documentation to improve improve usability, rendering performance, cross-platform stability—mentored by Professor David Doty",
      image: null,
      links: [
        { url: "https://scadnano.org/", label: "Scadnano Platform" },
        // { url: "https://github.com/UC-Davis-molecular-computing/scadnano", label: "GitHub Repository" }
      ],
    },
    {
      id: 6,
      title: "Bloom (STEM education program for local special needs and international underprivileged students)",
      // position: "Founder & Head Coordinator [in-progress]",
      // caption: "Taught Web Development, Java, and Computer-Aided Design to 70+ underserved students in 12 countries (mostly African); organized beg/adv groups; recruited 9 teachers from robotics team; partnered w/ GiveInternet.org",
      image: null,
      link: "https://www.learnwithbloom.org/",
    },
    {
      id: 7,
      title: "FRC Team: Robot Code (private), Website, Competition Data App, Analysis Website",
      // position: "Director of Software Division & Team Strategy Lead",
      // caption: "Lead 150+ members & $30K+ budget; develop computer vision target tracking & data analysis app/website handling ~5300 total matches; organize workshops.\nFIRST Robotics Worlds Qualifiers (1 of 3300+ teams) for San Francisco Comp. Finalists & Impact Award\nFIRST Robotics Competition Dean's List Semifinalist Award; 1 of 2 to receive out of 80+ members",
      image: null,
      links: [
        { url: "https://github.com/mvrt-115/frc2k25", label: "Robot Code (private)" },
        { url: "https://github.com/mvrt-115/mvrt-115.github.io", label: "MVRT Website" },
        { url: "https://github.com/mvrt-115/scout-app", label: '"Scouting" App' },
        { url: "https://github.com/mvrt-115/super-scout", label: '"Scouting" Website' },
      ],
    },
    // {
    //   id: 8,
    //   title: "Monta Vista Computer Science (CS) Club (largest programming club w/ 50+ members across 2 divisions)",
    //   // position: "Director of Main Division",
    //   // caption: "Prepare CS curricula; teach problem-solving skills; organize hackathons & mentors; doubled membership; only four-year American Computer Science League (ACSL) Senior Division participant\nACSL Senior Division 2x Finalist—for regular season competition top-scorers",
    //   image: null,
    //   links: [
    //     { url: "https://mv-compsci-club.github.io/", label: "CS Club Website" },
    //     { url: "https://www.scores.acsl.org/", label: "ACSL Competition Scores" }
    //   ],
    // },
    // {
    //   id: 9,
    //   title: "Cupertino Recreation Event Volunteers (teen volunteering group supporting Parks & Recreation events)",
    //   // position: "Founder & Co-President",
    //   // caption: "Lead 150+ total volunteers at 12 events; work w/ city staff; help teens hone soft & technical skills; tracked hours; executed in-person award ceremony",
    //   image: null,
    //   links: [
    //     { url: "https://www.cupertino.gov/Parks-Recreation/Activities/Teens/Teen-Volunteer-Opportunities/Recreation-Event-Volunteers", label: "REV Website" },
    //     { url: "https://www.instagram.com/p/DPkKqMvD_T4/?img_index=5", label: "Social Media Feature" }
    //   ],
    // },
    // {
    //   id: 10,
    //   title: "Cupertino Teen Commission (youth body to advise City Council on local issues/projects)",
    //   // position: "Commissioner",
    //   // caption: "Represented 8000+ youths; voice for teens in governance; spearheaded STEM project showcase at city community center & Youth-Led Org. highlight program—1 of 9 chosen",
    //   image: null,
    //   links: [
    //     { url: "https://www.cupertino.gov/Your-City/Commissions-and-Committees/Commissions/Teen-Commission", label: "Teen Commission Website" },
    //     { url: "https://www.instagram.com/p/Cpv8IM-PWt7/", label: "Social Media Feature" }
    //   ],
    // },
    // {
    //   id: 11,
    //   title: "Mentorship by Rayan Ansari",
    //   // position: "Researcher",
    //   // caption: "Developing ML models for a lightweight deep-learning pipeline to extract waveform segmentations from electrocardiogram images. Focus on connecting AI and health equity through scalable tools designed for low-resource healthcare settings.",
    //   image: null,
    // },
    {
      id: 12,
      title: 'Stanford Pre-Collegiate Summer Institutes ("Topics in Neuroengineering"): Hypersomnia',
      // position: "Student",
      // caption: "Presented research on mitigating hypersomnia by implanting electrodes to modulate abnormal neural activity. Used computational biology and advanced dataset techniques to analyze neural patterns and develop potential treatment approaches.",
      image: null,
      link: "https://docs.google.com/presentation/d/1aZi7aEk2_NktIsqNDlYoRpztfkbAjCgKNMqd7ZG-G-s/edit?usp=sharing",
    },
    // {
    //   id: 13,
    //   title: "Monta Vista Research Club",
    //   // position: "Member",
    //   // caption: "Used machine learning with Fast Fourier Transform to classify artificial media. Following year's project utilized Long Short-Term Memory networks for enhanced detection capabilities. Created detailed poster boards and presented findings at research showcases.",
    //   image: null,
    //   link: "https://mvresearch.weebly.com/",
    // },
    {
      id: 14,
      title: "McMahan Lab: Quantum Error Detection Mitigation",
      // position: "Research Intern",
      // caption: "Worked on quantum error detection and mitigation using Qiskit to investigate quantum noise and Graph Neural Networks. Presented research findings at a virtual colloquium, contributing to the advancement of quantum computing reliability.",
      image: null,
      links: [
        { url: "https://youtu.be/WQzXz4SnldI?si=9xAO-oqZFPJ5IWuH", label: "Colloquium Presentation Video" },
      ],
    },
    {
      id: 15,
      title: "Inspirit AI: Fake News Detection",
      // position: "Student",
      // caption: "Researched fake news and media detection, creating a machine learning bag-of-words model using Natural Language Processing techniques. Achieved high accuracy in detection and presented findings at a research showcase.",
      image: null,
      link: "https://docs.google.com/presentation/d/1AKt7-TsGjdNhrPsJtiR_uUPzhnMvXrpSG9b_4pIphzA/edit?usp=sharing",
    },
    // {
    //   id: 16,
    //   title: "Monta Vista Model United Nations",
    //   // position: "Public Relations Officer",
    //   // caption: "Researched and presented detailed national positions on global issues. Trained 30+ members in debate and diplomacy skills. Designed engaging social media posts and won awards at all conferences attended.\n2x Verbal Award\n1x Research Award",
    //   image: null,
    //   link: "https://montavistamun.com/awards",
    // },
    // {
    //   id: 17,
    //   title: "FIRST Lego League (FLL)",
    //   // position: "Mentor",
    //   // caption: "Started Team Brainstorm Troopers to introduce middle schoolers to LEGO robotics. Taught fundamental engineering and programming skills while helping develop an innovative AI-powered ocean smartwatch presentation for competition.",
    //   image: null,
    //   link: "https://www.firstlegoleague.org/",
    // },
    // {
    //   id: 18,
    //   title: "Little Grass Foundation",
    //   // position: "Coach",
    //   // caption: "Taught soccer fundamentals to 30+ diverse elementary schoolers from various backgrounds. Organized practices and adapted teaching methods to accommodate many different physical needs. Certified as a US Soccer match referee.\nPresident's Volunteer Service Gold Award",
    //   image: null,
    //   link: "https://www.littlegrassfoundation.org/meet-the-team",
    // },
  ];

  const [hoveredProject, setHoveredProject] = useState(null);
  const [selectedLinkIndex, setSelectedLinkIndex] = useState({});

  const handleProjectClick = (project) => {
    const currentIndex = selectedLinkIndex[project.id] || 0;
    const links = project.links || [{ url: project.link, label: "Link" }];
    const selectedLink = links[currentIndex];
    if (selectedLink && selectedLink.url !== "#") {
      window.open(selectedLink.url, "_blank", "noopener,noreferrer");
    }
  };

  const handleDotClick = (projectId, linkIndex, event) => {
    event.stopPropagation();
    setSelectedLinkIndex(prev => ({
      ...prev,
      [projectId]: linkIndex
    }));
  };

  return (
    <div className="projects-page">
      {/* About Section */}
      <section className="about-intro">
        <h1>Pranav Gupta</h1>
        <p>
          <a href="mailto:pranavgpta5@gmail.com">pranavgpta5@gmail.com</a>
        </p>
      </section>

      {/* Projects Section */}
      <div className="projects-grid">
        {projects.map((project) => {
          const links = project.links || [{ url: project.link, label: "Link" }];
          const currentIndex = selectedLinkIndex[project.id] || 0;
          const currentLink = links[currentIndex];
          const hasLinks = (project.links && project.links.length > 0) || (project.link && project.link !== "#");
          
          return (
            <div
              key={project.id}
              className={`project-card ${hasLinks && hoveredProject === project.id ? "hovered" : ""}`}
              onMouseEnter={() => { if (hasLinks) setHoveredProject(project.id); }}
              onMouseLeave={() => { if (hasLinks) setHoveredProject(null); }}
              onClick={() => {
                const hasLinks = (project.links && project.links.length > 0) || (project.link && project.link !== "#");
                if (hasLinks) handleProjectClick(project);
              }}
              style={{ cursor: hasLinks ? 'pointer' : 'default' }}
            >
              <div className="project-image-container">
                <div className="project-image">
                  {project.image ? (
                    <img src={project.image} alt={project.title} />
                  ) : (
                    <div className="placeholder-image">{project.title[0]}</div>
                  )}
                  {hasLinks && (
                    <div className="project-overlay">
                      <p>
                        Click for details
                        {links.length > 1 && (
                          <span className="link-label">
                            {currentLink.label}
                          </span>
                        )}
                      </p>
                    </div>
                  )}
                </div>
                {hasLinks && links.length > 1 && (
                  <div className="link-dots">
                    {links.map((link, index) => (
                      <button
                        key={index}
                        className={`dot ${index === currentIndex ? 'active' : ''}`}
                        onClick={(e) => handleDotClick(project.id, index, e)}
                        title={link.label}
                      />
                    ))}
                  </div>
                )}
              </div>
              <div className="project-info">
                <h3>{project.title}</h3>
                {/* <div className="project-position" style={{ color: 'black', fontSize: '0.9em', fontWeight: '500', marginBottom: '8px' }}>
                  {project.position}
                </div>
                <p dangerouslySetInnerHTML={{ __html: project.caption.replace(/\n/g, '<br/>') }}></p> */}
              </div>
            </div>
          );
        })}
      </div>
    </div>
  );
}

export default Projects;
